import React from 'react'

const PlusIcon = ({ fill }: { fill?: string }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke={fill ? fill : "currentColor"}>
            <path stroke-linejoin="round" d="M12 6v12m6-6H6" />
        </svg>
    )
}

export default PlusIcon